import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  onSignOut?: () => void;
  username?: string;
  userInfo?: any;
}

const Layout: React.FC<LayoutProps> = ({ children, onSignOut, username, userInfo }) => {
  const location = useLocation();

  const handleSignOut = () => {
    if (onSignOut) {
      onSignOut();
    }
  };

  const isAdmin = userInfo?.is_admin;

  const navigation = [
    { name: 'Dashboard', href: '/', current: location.pathname === '/' },
    { name: 'Organizations', href: '/organizations', current: location.pathname === '/organizations' },
    { name: 'Users', href: '/users', current: location.pathname === '/users' },
    { name: 'Stores', href: '/stores', current: location.pathname === '/stores' },
    ...(isAdmin ? [{ name: 'Dashboard Pages', href: '/dashboard-pages', current: location.pathname === '/dashboard-pages' }] : []),
    { name: 'WhatsApp Alerts', href: '/whatsapp', current: location.pathname === '/whatsapp' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg">
        <div className="flex h-16 items-center justify-center border-b border-gray-200">
          <h1 className="text-xl font-bold text-gray-900">Dashboard Manager</h1>
        </div>
        
        <nav className="mt-8 px-4">
          <ul className="space-y-2">
            {navigation.map((item) => (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    item.current
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="absolute bottom-4 left-4 right-4">
          {userInfo && (
            <div className="mb-3 px-4 py-2 bg-gray-100 rounded-md">
              <p className="text-xs text-gray-500">Signed in as</p>
              <p className="text-sm font-medium text-gray-900">{userInfo.username}</p>
              {userInfo.org_name && (
                <p className="text-xs text-gray-600">Organization: {userInfo.org_name}</p>
              )}
              {userInfo.is_admin && (
                <p className="text-xs text-blue-600 font-medium">System Administrator</p>
              )}
            </div>
          )}
          <button
            onClick={handleSignOut}
            className="w-full px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="pl-64">
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
